export function ImgChevronRight({ size = 16, expanded = false }: { size?: number; expanded?: boolean }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 16 16" fill="currentColor"
      style={{ transition: 'transform 0.2s ease', transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)' }}
    >
      <path d="M6 12l4-4-4-4v8z"/>
    </svg>
  );
}
